// product-form-new.js
export default (Alpine) => {
    Alpine.data("shippingGame", (
        selected_variant_id,
        selected_variant_title,
    ) => ({
		selected_variant_id: selected_variant_id,
		selected_variant_title: selected_variant_title,
        showWidget: false,
        cart: null,
        freeShippingThreshold: 9000,
        awayFromFreeShipping: 0,
        productsToReachFreeShipping: 0,
        
        addToCart() {
            console.log('addToCart');
        },
		
        async init() {
            await this.checkForFreeShipping();
			document.addEventListener('rebuy:cart.change', this.checkForFreeShipping.bind(this));
            console.log('variant', this.variant);
        },

        async checkForFreeShipping(e) {
            console.log('checkForFreeShipping');
            this.cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
            this.awayFromFreeShipping = this.freeShippingThreshold - this.cart.total_price;
            this.productsToReachFreeShipping = Math.ceil(this.awayFromFreeShipping / this.cart.total_price);
            console.log('productsToReachFreeShipping', this.productsToReachFreeShipping);
            if (this.productsToReachFreeShipping >= 1) {
                this.showWidget = true;
            } else {
                this.showWidget = false;
            }
			
		},

    }));
  };